/* src/app/shared/dialogs/flow-confirm-dialog/flow-confirm-dialog.component.scss */
:host {
  display: block;
}
.flow-confirm-dialog {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #e4e4e7;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-sizing: border-box;
}
.title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.quantity-row {
  display: flex;
  align-items: center;
  margin: 8px 0 4px;
}
.alertbox {
  margin: 12px 0;
  width: 100%;
  background: #fefce8;
  border: 1px solid #fde047;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  box-sizing: border-box;
}
.alert-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.alert-icon {
  filter: brightness(0) saturate(100%) invert(29%) sepia(88%) saturate(453%) hue-rotate(351deg) brightness(94%) contrast(99%);
}
.alert-title {
  color: #854d0e;
}
.alert-description {
  margin: 0;
  color: #18181b;
  font-family: "Poppins-Regular";
  font-size: 14px;
  line-height: 150%;
  white-space: pre-wrap;
  padding-left: 30px;
}
.button-row {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 4px;
}
::ng-deep .flow-confirm-dialog-panel .mat-mdc-dialog-surface {
  border-radius: 16px !important;
  padding: 0 !important;
  overflow: hidden;
}
/*# sourceMappingURL=flow-confirm-dialog.component.css.map */
